import React from "react";
import Zestawieniahtml2 from './Zestawienia_html_2.js';
import PrintComponents from "react-print-components";

export default class Print2 extends React.Component {
    constructor(props) {
        super();
        this.state = { data: props.data, stalytekst: props.stalytekst,  }
    }

    render() {
        let { data, stalytekst } = this.state
        return (
        <PrintComponents trigger={<button type="button" class="btn btn-light float-right"><i class="fas fa-print"></i> Drukuj</button>} >
        <Zestawieniahtml2 data={data} rok={this.props.rok} stalytekst={stalytekst} grupaZestawienValuetext={this.props.grupaZestawienValuetext} uchwala={this.props.uchwala}/>   
        </PrintComponents>
        );
    }
}
